import useBacktestStore from '../Store/backtestStore';

let ws = null;
let reconnectTimer = null;
let manualClose = false;

function getWsUrl() {

  // const envUrl = process.env.REACT_APP_BACKTEST_WS_URL;
  const envUrl = 'wss://regime-aware-meic-f1d64a53c44a.herokuapp.com/ws';
  if (envUrl) return envUrl;

  // Fallback: same host as frontend, /ws
  const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
  return `${protocol}://${window.location.host}/ws`;
}

export function connectBacktestWs() {
  const { setConnecting, setLoading, setReady, setError } = useBacktestStore.getState();

  // Prevent double-connect
  if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) {
    return () => {};
  }

  manualClose = false;
  setConnecting();

  ws = new WebSocket(getWsUrl());

  ws.onopen = () => {
    setLoading();
    try {
      ws.send(JSON.stringify({ type: 'get_backtest_data' }));
    } catch (err) {
      setError(`Failed to request backtest data: ${err?.message || err}`);
    }
  };

  ws.onmessage = (event) => {
    let msg;
    try {
      msg = JSON.parse(event.data);
    } catch {
      return;
    }

    if (msg.type === 'backtest_data') {
      setReady({
        stats: msg.stats || null,
        equitySeries: msg.equitySeries || []
      });
      return;
    }

    if (msg.type === 'backtest_data_error') {
      setError(msg.message || 'Backtest data error.');
      return;
    }
  };

  ws.onerror = () => {
    setError('WebSocket error.');
  };

  ws.onclose = (evt) => {
    if (manualClose) return;

    // Optional: don’t reconnect on normal close codes
    // 1000 = normal closure, 1001 = going away
    if (evt?.code === 1000 || evt?.code === 1001) return;

    clearTimeout(reconnectTimer);
    reconnectTimer = setTimeout(() => {
      connectBacktestWs();
    }, 1500);
  };

  return () => {
    manualClose = true;
    clearTimeout(reconnectTimer);
    reconnectTimer = null;

    try {
      ws?.close(1000, 'CLIENT_UNMOUNT');
    } catch (_) {}

    ws = null;
  };
}

